import script from "./HeaderView.vue?vue&type=script&lang=ts&setup=true"
export * from "./HeaderView.vue?vue&type=script&lang=ts&setup=true"

import "./HeaderView.vue?vue&type=style&index=0&id=42ef957d&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42ef957d"]])

export default __exports__